export const REFRESH_INTERVAL_MS = 5 * 60 * 1000 // 5 minutes in milliseconds
export const ANONYMOUS_ID_COOKIE_NAME = 'hypertuneId'
export const COOKIE_CONSENT_COOKIE_NAME = 'ConsentCookie'
